import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ExportHistoricoPlacaComponent } from "./export-historico-placa.component";
import { DownloadHistoricoPlacaComponent } from "./download-historico-placa/download-historico-placa.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesExportHistoricoPlacas: Routes = [
  {
    path: "",
    component: ExportHistoricoPlacaComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "download",
        component: DownloadHistoricoPlacaComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesExportHistoricoPlacas)],
  exports: [RouterModule],
})
export class ExportHistoricoPlacaRoutingModule {}
